import styled from 'styled-components'

import { ArrowIcon } from '../../icons/arrow-icon'

export const MenuContainer = styled.div`
    position: relative;
    cursor: pointer;
`

export const Menu = styled.ul`
    background-color: ${({ theme }) => theme.brandColors.CA_White};
    position: absolute;
    width: 100%;
    box-shadow: ${({ theme }) => theme.boxShadow};
    list-style: none;
    padding: unset;
    margin: unset;
    z-index: 1100;
    max-height: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    top: 100%;
    visibility: hidden;
    transition: max-height 0.3s ease;

    &.open {
        visibility: visible;
        max-height: 20vh;
    }
`

export const MenuItem = styled.li<{ active?: boolean }>`
    padding: 4px 10px;
    height: 32px;
    transition: background-color ${({ theme }) => theme.transition};
    background-color: ${({ theme, active }) => (active ? theme.brandColors.CA_Mid_Blue : theme.brandColors.CA_White)};
    color: ${({ theme, active }) => (active ? theme.brandColors.CA_Dark_Gray : theme.brandColors.CA_Black)};
    font-weight: 300;
    font-size: 16px;
    line-height: 1.5;
    overflow: hidden;
    white-space: nowrap;
    min-height: 25px;
    text-overflow: ellipsis;

    &:focus,
    &:hover {
        background-color: ${({ theme }) => theme.brandColors.CA_Light_Blue};
        color: ${({ theme }) => theme.brandColors.CA_Dark_Gray};
        width: 100%;
    }
    &.default-text {
        &:first-child {
            color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};
        }
    }
`

export const SArrowIcon = styled(ArrowIcon)<{ flipped: boolean }>`
    top: 0;
    bottom: 0;
    right: 15px;
    margin: auto 0;
    transform: rotate(${({ flipped }) => (flipped ? 0 : '180deg')});
    transition: transform 0.2s ease-in;
`

export const SDiv = styled.div<{ disabled: boolean }>`
    display: flex;
    align-items: center;
    padding-right: 1rem;
    gap: 5px;
    margin: auto 0;
    max-height: 20px;
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

    transition: transform 0.2s ease-in;

    &.read-only {
        display: none;
    }
`
